$('.js-nav-blog-mobile').on('change', function(event) {
  window.location.href = $(this)
    .find('option:selected')
    .data('url');
});
